import { DialogContent } from './ui/DialogContent';
import React from 'react';
import ImagePicker from './ImagePicker';
import { ResponsiveDialog } from './ui/ResponsiveDialog';
import { DialogHeader } from './ui/DialogHeader';

interface UpdateImageModalProps {
  open: boolean;
  onClose: () => void;
  handleImageCapture: (file: File) => void;
  compressionInProgress: boolean;
  compressionProgress: number;
}

const UpdateImageModal: React.FC<UpdateImageModalProps> = ({
  open,
  onClose,
  handleImageCapture,
  compressionInProgress,
  compressionProgress,
}) => {
  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      aria-labelledby="update-image-title"
    >
      <DialogHeader
        id="update-image-title"
        title="Update Image"
        onClose={onClose}
      />
      <DialogContent>
        <ImagePicker
          navigationKey="inventory.bulk.image"
          active={open}
          onImage={handleImageCapture}
          compressionInProgress={compressionInProgress}
          compressionProgress={compressionProgress}
        />
      </DialogContent>
    </ResponsiveDialog>
  );
};

export default UpdateImageModal;
